import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, unref as _unref, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "container-lil" }
const _hoisted_2 = { class: "search-view-input-set" }
const _hoisted_3 = { class: "secondary-font text-center my-2" }
const _hoisted_4 = { class: "grid-web3 mt-6" }
const _hoisted_5 = { class: "card px-2 py-2" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "font-semibold text-black mt-3 mb-4 px-4" }

import { API_CONFIG, BACKEND_URL } from '@/services/apiConfig';
    import debounce from 'lodash.debounce';
    import { onMounted, ref } from 'vue';
    import { useRoute } from 'vue-router';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'TutorialsListView',
  setup(__props) {

    const route = useRoute();
    const itemsList = ref([] as any[]);
    const query = ref("");

    onMounted(() => {
        const data: any = route.meta.startup_infos;
        itemsList.value = data;
        console.log(itemsList.value);
    });

    const search = debounce(async () => {
        const params = new URLSearchParams({
            q: query.value
        });
        const response = await fetch(`${API_CONFIG.baseURL}/tutoriels?${params.toString()}`, {
            method: 'GET',
            headers: API_CONFIG.headers
        });
        const responseData = await response.json();
        itemsList.value = responseData;
    }, 300);

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _cache[5] || (_cache[5] = _createElementVNode("div", { class: "page-space" }, null, -1)),
    _createElementVNode("section", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _withDirectives(_createElementVNode("input", {
          type: "text",
          class: "search-view-input",
          placeholder: "Faire une recherche...",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((query).value = $event)),
          onInput: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_unref(search) && _unref(search)(...args)))
        }, null, 544), [
          [_vModelText, query.value]
        ]),
        _cache[2] || (_cache[2] = _createStaticVNode("<button class=\"btn-ultra white tips\"><div class=\"btn-show\"><img src=\"/public/icons/icon-go.svg\" class=\"btn-icon\" alt=\"\"></div><div class=\"btn-loading\"><div class=\"loader-dots\"></div></div></button>", 1))
      ]),
      _cache[3] || (_cache[3] = _createElementVNode("div", { class: "h-30" }, null, -1)),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(itemsList.value, (categorie) => {
        return (_openBlock(), _createElementBlock("div", {
          key: 'categorie_' + categorie.id,
          class: "mb-10"
        }, [
          _createElementVNode("h1", _hoisted_3, _toDisplayString(categorie.libelle), 1),
          _createElementVNode("div", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(categorie.aides, (aide) => {
              return (_openBlock(), _createBlock(_component_router_link, {
                key: 'item_' + aide.id,
                to: '/tutoriels/' + aide.slug
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_5, [
                    (aide.fichier_photo)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          src: _unref(BACKEND_URL) + '/assets/aide/1000/' + aide.fichier_photo,
                          width: "100%",
                          class: "mb-5",
                          alt: ""
                        }, null, 8, _hoisted_6))
                      : _createCommentVNode("", true),
                    _createElementVNode("h5", _hoisted_7, _toDisplayString(aide.libelle), 1)
                  ])
                ]),
                _: 2
              }, 1032, ["to"]))
            }), 128))
          ])
        ]))
      }), 128)),
      _cache[4] || (_cache[4] = _createElementVNode("div", { class: "clear-both h-40" }, null, -1))
    ])
  ], 64))
}
}

})